<template>
  <van-popup
    class="rule-popup"
    :value="ruleFlag"
    round
    position="bottom"
    @click-overlay="close"
    duration="0.2"
  >
    <img class="popup-btn" :src="icon_close" alt="" @click="close" />
    <h5 class="rule-title">{{ jsonRules.activityRules }}</h5>
    <div class="rule-wrapper">
      <p class="rule-item" v-for="(v, i) in ruleInfo.ruleList" :key="i">{{ v }}</p>
    </div>
  </van-popup>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
  computed: {
    ...mapState({
      ruleFlag: state => state.ruleFlag,
      ruleInfo: state => state.ruleInfo,
      jsonRules: state => state.jsonRules
    })
  },
  data() {
    return {
      icon_close: require('../images/close.png')
    };
  },
  methods: {
    ...mapMutations(['setState']),
    close() {
      this.setState({
        ruleFlag: false
      });
    }
  }
};
</script>
<style lang="less">
.rule-popup {
  display: flex;
  flex-direction: column;
  padding: 40px;
  height: 50%;
  border-radius: 20px 20px 0 0;
  overflow-y: unset;
  .popup-btn {
    position: absolute;
    width: 72px;
    height: 72px;
    left: 40px;
    top: -102px;
  }
  .rule-title {
    margin-bottom: 40px;
    line-height: 67px;
    font-family: PingFangSC-Medium;
    font-size: 48px;
    color: #222222;
  }
  .rule-wrapper {
    flex: 1;
    overflow-y: auto;
    .rule-item {
      margin-bottom: 30px;
      line-height: 37px;
      font-family: PingFangSC-Regular;
      font-size: 26px;
      color: #666666;
    }
  }
}
</style>
